import { FileUploader } from 'react-drag-drop-files';
import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';

interface FileSelectorProps {
  value: File | null;
  types: string[];
  onChangeFile: (file: File) => void;
}

export const FileSelector: FC<FileSelectorProps> = (props) => {
  return (
    <FileUploader
      handleChange={props.onChangeFile}
      name="file"
      types={props.types}
    >
      <div className="borderless cursor-pointer">
        {!props.value ? (
          <Typography align="center" variant="subtitle1" color="secondary">
            De clic aquí para seleccionar el archivo o arrastre el archivo desde
            su directorio
          </Typography>
        ) : (
          <Stack direction="row" alignItems="center" justifyContent="center">
            <Check fontSize="inherit" sx={{ marginRight: 1 }} />
            <Typography align="center" variant="subtitle1" color="secondary">
              De clic aquí para seleccionar otro archivo
            </Typography>
          </Stack>
        )}
      </div>
    </FileUploader>
  );
};
